import React, { useRef, useState } from "react";
import {
  APIProvider,
  ControlPosition,
  Map,
  MapControl,
} from "@vis.gl/react-google-maps";
import { useSearchParams } from "react-router-dom";

export default function MyMap({
  isPage,
  children,
  closeOverlay,
  zoom,
  mapTypeControl = true,
}: {
  isPage?: boolean;
  children: any;
  closeOverlay?: () => void;
  zoom?: number | undefined;
  mapTypeControl?: boolean;
}) {
  const mapContainerRef = useRef<HTMLDivElement | null>(null);
  const [isMapFocused, setIsMapFocused] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const localStorageBounds = JSON.parse(
    localStorage.getItem("mapBounds") || "null"
  );
  const defaultBounds: {
    north: number;
    south: number;
    east: number;
    west: number;
  } = {
    north: parseFloat(
      searchParams.get("north") || localStorageBounds?.north || "60"
    ),
    south: parseFloat(
      searchParams.get("south") || localStorageBounds?.south || "40"
    ),
    east: parseFloat(
      searchParams.get("east") || localStorageBounds?.east || "60"
    ),
    west: parseFloat(
      searchParams.get("west") || localStorageBounds?.west || "-20"
    ),
  };

  return (
    <APIProvider apiKey={(window as any).GM_API_KEY} version="3.64">
      <div className="h-100 d-flex flex-column ">
        {children}
        <div className="flex-grow-1 position-relative d-flex flex-column mt-1">
          <div
            className="flex-grow-1 rounded-2"
            ref={mapContainerRef}
            tabIndex={0}
            onFocus={() => setIsMapFocused(true)}
            onBlur={() => setIsMapFocused(false)}
            onMouseDown={() => mapContainerRef.current?.focus()}
            style={{
              border: isMapFocused
                ? "2px solid #0d6efd"
                : "2px solid transparent",
              boxSizing: "border-box",
              transition: "border-color 120ms ease",
            }}
          >
            <Map
              mapId={"map"}
              gestureHandling={"greedy"}
              minZoom={4}
              onClick={closeOverlay}
              onIdle={(e) => {
                closeOverlay?.();
                localStorage.setItem(
                  "mapBounds",
                  JSON.stringify(e.map.getBounds()?.toJSON())
                );
                if (!isPage) {
                  return;
                }
                setTimeout(() => {
                  const b: any = e.map.getBounds()?.toJSON();
                  setSearchParams(b, { replace: true });
                }, 100);
              }}
              streetViewControl={false}
              zoomControl={!zoom}
              zoom={zoom}
              defaultBounds={defaultBounds}
              scrollwheel={!zoom && isMapFocused}
              mapTypeControl={mapTypeControl}
            >
              <MapControl position={ControlPosition.TOP_CENTER} />
            </Map>
          </div>
        </div>
      </div>
    </APIProvider>
  );
}
